import { FC, useState } from 'react';
import { NudosCareCard } from './NudosCareCard';
import { IBasicProductsCare, IProductsCare, IProductsPerCategory } from '../../../../../types/bussines';
import { LoadingOutlined } from '@ant-design/icons';
import alertMessage from '../../../../../utils/alertMessage';
import { ResetIcon } from '../../../../../assets/images';
import { displayErrorNotification } from '../../../../../utils/displayNudosStandardNotifications';
import { getOrganizationInventoryURL } from '../../../../../services/bussines';
import { useParams } from 'react-router-dom';
import { IconBlueDownLoad } from '../../../../../assets/DesignSystem/SVGComponents';
import './NudosCareTab.scss';
interface INudosCareTab {
  productsCare: IProductsCare[];
  careProductsUpdate: (e: IBasicProductsCare[]) => void;
  setDinamicProductList: (e: IBasicProductsCare[]) => void;
  dinamicProductList: IBasicProductsCare[];
  setIsEditable: (e: boolean) => void;
  isEditable: boolean;
  loadingUpdateCare: boolean;
  cancelUpdate: () => void;
  productsPerCategory: IProductsPerCategory[];
}

const NudosCareTab: FC<INudosCareTab> = ({
  productsCare,
  careProductsUpdate,
  setDinamicProductList,
  dinamicProductList,
  setIsEditable,
  isEditable,
  loadingUpdateCare,
  cancelUpdate,
  productsPerCategory
}: INudosCareTab) => {
  const { organizationId } = useParams<{ organizationId: string }>();

  const [loadingDownLoad, setLoadingDownLoad] = useState<boolean>(false);

  const handleEditProductsCare = (e: IBasicProductsCare) => {
    if (e) {
      const findProduct = dinamicProductList.find(element => element.productId === e.productId);
      if (findProduct) {
        findProduct.nudosCare = e.nudosCare;
        setDinamicProductList([...dinamicProductList]);
      } else {
        setDinamicProductList([...dinamicProductList, e]);
      }
    }
  };

  const saveCare = () => careProductsUpdate(dinamicProductList);

  const productsPerCategoryList = productsPerCategory?.map((item, index) => {
    return (
      <span key={`product-per-category-${item.category}-${index}`}>{`${item.numberOfTools} ${item.category} ${
        index + 1 !== productsPerCategory.length ? '/' : ''
      } `}</span>
    );
  });

  const downLoadAction = async () => {
    if (loadingDownLoad) return;
    setLoadingDownLoad(true);
    try {
      const urlResume = await getOrganizationInventoryURL(organizationId);
      if (urlResume) window.open(urlResume, '_blank');
    } catch (error) {
      displayErrorNotification();
    } finally {
      setLoadingDownLoad(false);
    }
  };

  return (
    <div id="nudosCareTab">
      <div className="titleCare">
        Devices en inventario
        {!loadingDownLoad && (
          <div className="downLoadResume" onClick={downLoadAction}>
            Descargar
            <IconBlueDownLoad />
          </div>
        )}
        {loadingDownLoad && <div className="inputSkeletonLoader animationLoader" />}
      </div>
      <span className="subtitleDevices">{`${productsCare && (productsCare?.length || 0)} devices - `}</span>
      {productsPerCategory && productsPerCategory.length > 0 && (
        <span className="styleTextDevices">{productsPerCategoryList}</span>
      )}
      <div className="headerCare">
        <div className="toolName">Herramientas</div>
        <div className="careName">Nudos Care</div>
        <div
          className="saveButton"
          onClick={() => {
            if (!isEditable) {
              alertMessage('Ahora puedes edita los planes de Nudos care de los seriales ');
              setIsEditable(true);
            } else {
              if (dinamicProductList && dinamicProductList.length > 0) saveCare();
            }
          }}
        >
          {loadingUpdateCare ? (
            <>
              <LoadingOutlined />
            </>
          ) : (
            <> {isEditable ? 'Guardar' : 'Editar'}</>
          )}
        </div>
        {!loadingUpdateCare && (
          <div
            className={`cancelIcon ${isEditable ? 'enabledResetButton' : 'disabledResetButton'}`}
            onClick={() => {
              if (isEditable) {
                if (dinamicProductList.length > 0) {
                  cancelUpdate();
                } else {
                  setIsEditable(false);
                }
              }
            }}
          >
            <ResetIcon stroke={!isEditable ? '#CCCCCC' : ''} />
          </div>
        )}
      </div>
      <div className="containerDevices">
        {productsCare &&
          productsCare.length > 0 &&
          productsCare.map(item => {
            return (
              <NudosCareCard
                key={`product-care-${item.productId}`}
                dataCareCard={item}
                isEditable={isEditable}
                handleEditProductsCare={handleEditProductsCare}
              />
            );
          })}
      </div>
    </div>
  );
};
export default NudosCareTab;
